import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { TextLink } from '@app/components/core/link/TextLink'

export const LoadMoreCommentsButton = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) => {
  return (
    <TextLink
      containerStyle={{ alignSelf: 'start' }}
      icon={faPlus}
      iconPosition="left"
      onClick={onClick}
    >
      {label}
    </TextLink>
  )
}
